// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__3wAQP","ButtonMobile":"Button_ButtonMobile__rl0P-","error":"Button_error__MWVqz","success":"Button_success__IhKLw","primary":"Button_primary__xCfgJ"};